import { render, staticRenderFns } from "./CurriculumListEECJournalRow.vue?vue&type=template&id=4fa66977&scoped=true&"
import script from "./CurriculumListEECJournalRow.vue?vue&type=script&lang=ts&"
export * from "./CurriculumListEECJournalRow.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumListEECJournalRow.vue?vue&type=style&index=0&id=4fa66977&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa66977",
  null
  
)

export default component.exports